export type TaskTiming = "overdue" | "today" | "later" | "none";

const endOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).getTime();

/** Overdue: due before now. Today: due later today. Later: after today. */
export const taskTiming = (
  due: string | null | undefined,
  now: Date,
): TaskTiming => {
  if (!due) return "none";
  const time = new Date(due).getTime();
  if (time < now.getTime()) return "overdue";
  if (time < endOfDay(now)) return "today";
  return "later";
};

/** End of the current day as ISO, for "due today or earlier" queries */
export const endOfTodayIso = (now: Date) =>
  new Date(endOfDay(now)).toISOString();
